module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Devise","track":"Currency"}}